import { SelectData } from "../../models";

export class ProjectIssuanceTransactionConstants {
  public static readonly DEFAULT_ISSUANCE_TRANSACTION = {
    areaHa: null,
    broker: null,
    counterParty: null,
    externalReference: null,
    fees: null,
    issuanceUuid: null,
    parentTransactionUuid: null,
    price: null,
    quantity: null,
    totalValue: null,
    transactionDate: null,
    type: null,
    rowVersion: null,
    uuid: null,
  };

  public static readonly ISSUANCE_TRANSACTION_TYPE_RESERVED = "Reserved";

  public static readonly ISSUANCE_TRANSACTION_TYPE_SOLD = "Sold";

  public static readonly ISSUANCE_TRANSACTION_TYPE_CANCELLED = "Cancelled";

  public static readonly ADD_ISSUANCE_TRANSACTION_TYPE_SELECT_DATA = [
    {
      key: ProjectIssuanceTransactionConstants.ISSUANCE_TRANSACTION_TYPE_RESERVED,
      value: ProjectIssuanceTransactionConstants.ISSUANCE_TRANSACTION_TYPE_RESERVED,
    },
    {
      key: ProjectIssuanceTransactionConstants.ISSUANCE_TRANSACTION_TYPE_SOLD,
      value: ProjectIssuanceTransactionConstants.ISSUANCE_TRANSACTION_TYPE_SOLD,
    },
  ] as SelectData;

  public static readonly APPEND_ISSUANCE_TRANSACTION_TYPE_SELECT_DATA = [
    {
      key: ProjectIssuanceTransactionConstants.ISSUANCE_TRANSACTION_TYPE_SOLD,
      value: ProjectIssuanceTransactionConstants.ISSUANCE_TRANSACTION_TYPE_SOLD,
    },
    {
      key: ProjectIssuanceTransactionConstants.ISSUANCE_TRANSACTION_TYPE_CANCELLED,
      value: ProjectIssuanceTransactionConstants.ISSUANCE_TRANSACTION_TYPE_CANCELLED,
    },
  ] as SelectData;
}
